export default "__VITE_ASSET__EtNX0Sec__"